import axios from "axios";

import cssVars from "css-vars-ponyfill";
window.cssVars = cssVars;

// Use ES6 import for axios
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["X-CSRF-TOKEN"] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

// Add missing constants
window.TRANSPARENT = '#00000000';

// Add lodash get function to window
import get from "lodash/get";
window.get = get;

// Add missing themeCssVariables constant
window.themeCssVariables = {
    bodyFontColor: { value: '#000000' },
    bodyBackgroundColor: { value: '#ffffff' }
};

// Note: Alpine.js and components are now set up in app.js
